import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'
import logo from '../../image/logo.png' 
import { Link } from "react-router-dom"; 



const Nav = () => {
  const [toggle, setToggle] = useState(false);
  const styleName = toggle? 'open' : 'closed'

  const handleToggle = () => {
    setToggle(!toggle);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <nav className={toggle? 'nav expanded':'nav'}> 

      <Link to="/home">
      <div className="img">
                  <img src={logo} alt=""/>
              </div>
              
            </Link>
        
        <Navbar fixed="top" styleName={styleName}/>
        <div className='toggle-icon' onClick={handleToggle}>
          {toggle?<i className="fa-solid fa-xmark"></i>:<i className="fa-solid fa-bars"></i>} 
        </div>
        
    </nav>
  )
}



export default Nav
